// extracted by mini-css-extract-plugin
export default {"users_page":"Users_users_page__cKPII","buttons_container":"Users_buttons_container__ZOejG","users_content":"Users_users_content__FQ4xb"};